<template>
  <div class="difficulty">
    <div class="content">
      <h2 style="padding-top: 50px; padding-bottom: 28px;">初中重难点APP关停公告</h2>
      <p class="detail-title">家长/同学您好：</p>
      <p class="intro">很抱歉的通知您初中重难点业务目前已停止运营，App将于2022年2月17日正式下线。现将退费等相关事宜与您告知：</p>
      <p class="detail" style="margin-top: 21px">1.会员退费</p> 
      <p class="detail">如您购买过会员，无论何时购买，我们都会按照实际支付金额进行全额退款。退款事宜将于2022年2月16日中午12:00开始处理，费用会在10个工作日内退回原账户。如果支付过程中使用过礼品卡或优惠券，礼品卡或优惠券会陆续返回您的账户。感谢您的理解与耐心等待。 </p>
      <p class="detail" style="margin-top: 21px">2.礼品卡 </p>
      <p class="detail">您之前通过【学而思网校优惠券】兑换的【初中重难点礼品卡】都将换回【学而思网校优惠券】。 </p>
      <p class="detail" style="margin-top: 21px">3.寒假打卡活动 </p>
      <p class="detail">由于App关停，寒假打卡抽奖活动确定于2022年2月17日12:00下线，感谢您的积极参与。</p>
      <p class="detail" style="margin-top: 21px">作为一款数字教辅类的自学工具，我们致力于通过个性化方式让自主学习更轻松更有趣，希望在之后的学习生活中，您能够继续体会到自主学习的快乐。感谢您的理解与支持，给您带来的不便敬请见谅。</p>
      <p class="detail" style="margin-top: 21px; text-align: right; margin-top: 81px;">初中重难点团队</p>
      <p class="detail" style=" text-align: right; padding-bottom: 31px;">2022年2月15日</p>
    </div>
  </div>
</template>
<script>
import configFn from "@/env";
export default {
  name: "homePage",
  data() {
    return {
      config: null,
    };
  },
  created() {
    this.config = configFn(0);
  },
};
</script>
<style lang="scss" scoped>
.banner {
  img {
    width: 100%;
  }
}
.difficulty {
  text-align: center;
  background-color: rgba(228, 24, 27, 1);

  .content {
      width: 777px;
      display: block;
      text-align: left;

      h2 {
        padding: 0;
        margin: 0;
      }

      p {
        padding: 0;
        margin: 0;
      }

      .intro { 
        height: auto;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 30px;
      }

      .detail {        
        height: auto;

        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 21px;
      }

    .detail-title { 
        height: auto;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 22px;
    }

    h2 { 
        height: auto;
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 68px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
.path {
  width: 100%;
  background-color: rgb(250, 249, 249);
  padding-bottom: 50px;
}
.title {
  font-size: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 48px;
  text-align: center;
  padding: 40px 0 20px;
}
.content {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  .item {
    width: 20%;
  }
}
.chart {
  width: 100%;
  //   height: 204px;
}
.name {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 33px;
  margin: 12px 0 4px;
}
.info {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}
@media screen and (max-width: 900px) {
  .name {
    font-size: 18px;
  }
  .info {
    font-size: 14px;
    line-height: 20px;
  }
}
@media screen and (max-width: 700px) {
  .difficulty {

    .content {
        width: auto;
        padding: 0 40px;
    }
  }
  .content {
    flex-wrap: wrap;
    .item {
      width: 40%;
    }
  }
  .title {
    font-size: 30px;
  }
  .name {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 26px;
    margin: 12px 0 4px;
  }
  .info {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
  }
}

@media screen and (max-width: 420px) {
  .title {
    font-size: 26px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .item {
      width: 70%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (max-width: 300px) {
  .title {
    font-size: 22px;
  }
}
</style>
